<template>
  <div class="about-author-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="about-author-content">
            <div class="author-content">
              <div class="thumb">
                <!-- 仅在 Profile 路由显示上传按钮 -->
                <el-upload
                  v-if            = "isProfileRoute"
                  class           = "avatar-uploader"
                  action          = "#"
                  :show-file-list = "false"
                  :on-success     = "handleAvatarSuccess"
                  :before-upload  = "beforeAvatarUpload"
                  :http-request   = "uploadAvatar"
                >
                  <div class="avatar-container">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <div class="avatar-uploader-icon">
                      <i class="el-icon-camera-solid"></i>
                    </div>
                  </div>
                </el-upload>
                <!-- 非 Profile 路由仅显示头像 -->
                <div v-else class="avatar-container">
                  <img :src="imageUrl" class="avatar">
                </div>
              </div>
              <!-- 使用 profile 动态数据 -->
              <h3 class="title">{{ profile?.realname || '默认姓名' }}</h3>
              <ul>
                <li>{{ profile?.company || '' }}</li>
                <li>{{ profile?.position || '' }}</li>
              </ul>
              <div class="text">
                <el-tag v-if="profile?.realname && !/[0-9]/.test(profile.realname)">已实名认证</el-tag>
                <el-tag v-else>未实名认证</el-tag>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style>
.author-content .thumb {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
  overflow: hidden;
  height: 115px;
  width: 115px;
  text-align: center;
  border: 2px solid #e4e5e6;
  background-color: transparent;
}

/* 调整头像容器样式，确保无额外内边距影响居中 */
.avatar-container {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0; /* 移除可能的内边距 */
  margin: 0;  /* 移除可能的外边距 */
}

/* 优化头像图标居中样式 */
.avatar-uploader-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;  /* 垂直居中 */
  justify-content: center;  /* 水平居中 */
  background: rgba(0, 0, 0, 0.5);
  color: white;
  opacity: 0;
  transition: opacity 0.3s ease;
  font-size: 24px;
  line-height: 1;
  padding: 0;
  margin: 0;
  box-sizing: border-box; /* 确保内边距不影响尺寸 */
  transform: translateY(0); /* 重置垂直位置 */
}

/* 修复父容器行高干扰 */
.author-content .thumb {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
  overflow: hidden;
  height: 115px;
  width: 115px;
  text-align: center;
  /* 移除行高，避免干扰子元素垂直居中 */
  /* line-height: 112px; */ 
  border: 2px solid #e4e5e6;
}

/* 鼠标悬停时显示图标 */
.avatar-container:hover .avatar-uploader-icon {
  opacity: 1;
}

/* 头像图片样式 */
.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block; 
  min-width: 100%;
  min-height: 100%;
}
</style>

<script>
import { postAvatar } from '@/api/user';

export default {
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    imageUrl() {
      return this.profile?.avatarurl || require('@/assets/images/default_avatar.png');
    },
    // 添加计算属性判断当前是否为 Profile 路由
    isProfileRoute() {
      return this.$route.name === 'Profile';
    }
  },
  methods: {
    handleAvatarSuccess() {
      console.log('avatar success');
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/png' || file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false;
      }
      return isJPG || isPNG && isLt2M;
    },
    async uploadAvatar(options) {
      try {
        const res = await postAvatar(options.file);
        if (res.code === 200) {
          this.$message({
            message: '上传成功',
            type: 'success'
          });
          if (this.$route.name !== 'Profile') { 
            this.$router.push({ name: 'Profile' });
          }
          this.$emit('refreshProfile');

        } else {
          this.$message({
            message: res.err || '上传失败',
            type: 'error'
          });
        }
      } catch (error) {
        this.$message({
          message: error.message || '上传失败',
          type: 'error'
        });
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>